module.exports = "<post-editor post=post form=form lock-id=lockId ng-if=form.id></post-editor> ";


//////////////////
// WEBPACK FOOTER
// ./app/main/posts/modify/main.html
// module id = 830
// module chunks = 0